import {
  Text,
  Primary14SemiBold,
  GreyGrey80
} from '@sequencehq/core-components'

export const Title = ({ children }: { children: string }) => (
  <Text {...Primary14SemiBold} color={GreyGrey80}>
    {children}
  </Text>
)
